import { html, render } from "lit-html";
import "./loginScreen.css";
import smallBg from "./smallbg.jpg";
import bigBg from "./bg.jpg";
import "./icon/css/fontello.css";
import { tips } from "~src/tips/index.js";
import { mobileOrNot } from "~/src/helpers/mobileDetect.js";
import { exitButtonPosition } from "../../helpers/exitButtonPosition";
import { pickText } from "../../textcontents";
export const answers = {
  correctAnswer: false,
  wrongAnswers: 0,
  correctValue: "MATRIX",
  processing: false,
  answersDisabled: false,
  loginDisabled: false
};

let loginSuccessCallback;

const getInputValue = () => {
  var inputVal = document.querySelector(".psw_input").value.toUpperCase();
  if (inputVal.length === 0) return false;

  answers.processing = true;

  if (inputVal === answers.correctValue) {
    answers.correctAnswer = true;
    answers.loginDisabled = true;
    Login();
    return;
  } else {
    answers.wrongAnswers++;
    document.querySelector(".psw_input").value = "";
  }

  answers.processing = false;
  Login();
};

const textToShow = () => {
  if (answers.processing) {
    return html`<p>${pickText("twitter", 6)}</p>`;
  }

  if (!answers.processing && answers.correctAnswer) {
    tips.solveMatrix.clear();
    return html`<p> ${pickText("twitter", 5)}</p>`;
  } else if (!answers.processing && answers.wrongAnswers === 0) {
    return html`<p> ${pickText("twitter", 1)}</p>`;
  } else {
    return html`<div>
      <p> ${pickText("twitter", 4)}</p>
      <small> </small>
    </div>`;
  }
};

let BgLoaded = false;

const Markup = () => html`<div class="login-screen">
  <div class="image-container" data-large=${bigBg}>
    <img
      src=${bigBg}
      @load=${() => {
        BgLoaded = true;
        Login();
      }}
    />
  </div>
  <main class="input-container">
    ${answers.loginDisabled
      ? html`<section>${pickText("twitter", 7)}</section>`
      : html`<section class="inputWithIcon">
          <input
            type="text"
            placeholder=""
            class="psw_input"
            @input="${() => {
              window.scene.getSoundByName("matrixKeyboard")?.play();
            }}"
          />
          <i class="icon-lock" aria-hidden="true"></i>
          ${textToShow()}
          <div style="display: flex; flex-direction: column;">
          <button type="button" @click="${() => getInputValue()}">
          ${pickText("twitter", 2)}
          </button>
         <button type="button" style="background: #e0305a;" @click="${() => {window.currentModalExit(); document.querySelector(".exit-button").style.display = "initial" }}">
        ${pickText("twitter", 3)}
        </button></div>
        </section>`}
  </main>
</div>`;

let container;

const Login = (puzzleWindow, loginSucceeded) => {
  if (puzzleWindow && loginSucceeded) {
    //
    loginSuccessCallback = loginSucceeded;
    container = puzzleWindow;
  }
  if (answers.loginDisabled) {
    window.setTimeout(loginSuccessCallback, 2000);
  }
  if (!BgLoaded) {
    render(Markup(), container({ hidden: true }));
  } else {
    render(Markup(), container({ hidden: false }));
  }
};

export default Login;
